import React from "react";

export default function Loader() {
    return (<span className="loader"><div></div><div></div><div></div><div></div></span>);
}
